module.exports = __webpack_public_path__ + "img/w矩形 79@3x.26a66102.png";